<div class="health-indicator" (mouseenter)="onMouseEnter()" (mouseleave)="detailsOpen = false">
  <!-- Pill de status: ponto colorido + resumo + info -->
  <button
    type="button"
    class="health-pill"
    [matTooltip]="tooltip"
    matTooltipPosition="below"
    [attr.aria-label]="'Status dos serviços: ' + summaryLabel"
    [attr.aria-expanded]="detailsOpen"
    (click)="toggleDetails()">
    <span class="health-pill__dot" [ngClass]="ledClass"></span>
    <span class="health-pill__text">{{ summaryLabel }}</span>
    <i class="fas fa-info-circle health-pill__info" aria-hidden="true"></i>
  </button>

  <!-- Popover de detalhes -->
  <div
    *ngIf="detailsOpen"
    class="health-popover"
    role="dialog"
    aria-label="Detalhes de saúde dos serviços">

    <div class="health-popover__header">
      <span class="health-led health-led--inline" [ngClass]="ledClass"></span>
      <span class="health-popover__title">{{ headerMessage }}</span>
    </div>

    <ul class="health-popover__list">
      <!-- Banco de dados (MongoDB) -->
      <li class="health-popover__item">
        <span class="health-led health-led--inline" [ngClass]="ledClassFor(mongoDb?.status)"></span>
        <div class="health-popover__body">
          <span class="health-popover__name">{{ 'health.services.database' | transloco }}</span>
        </div>
        <span class="health-popover__status">{{ statusLabel(mongoDb?.status) }}</span>
      </li>

      <!-- Mensageria (RabbitMQ) -->
      <li class="health-popover__item">
        <span class="health-led health-led--inline" [ngClass]="ledClassFor(rabbitMq?.status)"></span>
        <div class="health-popover__body">
          <span class="health-popover__name">{{ 'health.services.messaging' | transloco }}</span>
        </div>
        <span class="health-popover__status">{{ statusLabel(rabbitMq?.status) }}</span>
      </li>

      <!-- Mercado Livre (grupo visual, detalhes técnicos separados) -->
      <li class="health-popover__item health-popover__group">
        <span class="health-led health-led--inline" [ngClass]="ledClassFor(mercadoLivre.displayStatus)"></span>
        <div class="health-popover__body">
          <span class="health-popover__name">{{ 'health.services.mercadoLivre' | transloco }}</span>

          <ul class="health-popover__subitems">
            <li class="health-popover__subitem">
              <span class="health-led health-led--dot" [ngClass]="ledClassFor(mercadoLivre.apiReachable?.status)"></span>
              <div class="health-popover__subbody">
                <span class="health-popover__subname">{{ 'health.services.availability' | transloco }}</span>
              </div>
              <span class="health-popover__status">{{ statusLabel(mercadoLivre.apiReachable?.status) }}</span>
            </li>

            <li class="health-popover__subitem">
              <span class="health-led health-led--dot" [ngClass]="ledClassFor(mercadoLivre.authValid?.status)"></span>
              <div class="health-popover__subbody">
                <span class="health-popover__subname">{{ 'health.services.authentication' | transloco }}</span>
              </div>
              <span class="health-popover__status">{{ statusLabel(mercadoLivre.authValid?.status) }}</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>

    <div class="health-popover__footer">
      <span>{{ 'health.lastCheck' | transloco }}</span>
      <span>{{ health.checkedAt ? (health.checkedAt | date:'HH:mm:ss') : ('health.waiting' | transloco) }}</span>
    </div>
  </div>
</div>
